<template>
  <div class="company-tooltip">
    <a-tooltip
      v-if="$getStrleng(text.fieldvalue) > 10"
      :title="text.fieldvalue"
      overlay-class-name="td-tooltip"
    >
      <div class="tdDefineStyle">
        {{ $substr(text.fieldvalue, 10) }}
      </div>
    </a-tooltip>
    <span
      v-else
    >
      {{ text.fieldvalue || '- -' }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: Object,
      default: () => { }
    }
  }
}
</script>
